import React from "react";
import { Link } from "@/components/LocaleLink";
import { Phone, Mail, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/i18n/translations";
import { Reveal } from "@/components/Reveal";

const FinalCTA = () => {
  const { t } = useLang();
  return (
    <section className="relative overflow-hidden bg-[#EAE5D9]" data-testid="final-cta">
      <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-[#8EA694]/25 blur-3xl" aria-hidden="true" />
      <div className="absolute -left-16 bottom-0 h-64 w-64 rounded-full bg-[#C47C5D]/15 blur-3xl" aria-hidden="true" />
      <div className="relative max-w-5xl mx-auto px-5 sm:px-8 py-24 lg:py-32 text-center">
        <Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A2E24] leading-[1.05] max-w-3xl mx-auto">
            {t.finalCta.title}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-lg text-[#3B5245] max-w-2xl mx-auto leading-relaxed">{t.finalCta.subtitle}</p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/kontakt"
              className="group inline-flex items-center gap-2 rounded-full bg-[#2D5A3F] text-white px-8 py-4 font-medium hover:bg-[#1A2E24] transition-colors duration-300"
              data-testid="cta-contact-button"
            >
              {t.finalCta.button}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <div className="flex items-center gap-6 text-[#3B5245]">
              <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2 font-medium hover:text-[#2D5A3F] transition-colors" data-testid="cta-phone">
                <Phone className="h-4 w-4" /> {CONTACT.phone}
              </a>
              <a href={`mailto:${CONTACT.email}`} className="hidden sm:flex items-center gap-2 font-medium hover:text-[#2D5A3F] transition-colors" data-testid="cta-email">
                <Mail className="h-4 w-4" /> {CONTACT.email}
              </a>
            </div>
          </div>
        </Reveal>
        <p className="mt-10 font-display text-2xl text-[#5C7567] italic">— {t.finalCta.signature}</p>
      </div>
    </section>
  );
};

export default FinalCTA;
